import { Dialog } from '@sm-dashboard/ui-components';
import { useState, type ReactNode } from 'react';
import DynamicDialog from '../DaynmicDialog';

type AddPostMobileSheetProps = {
  open: boolean;
  /** When true, closing asks for confirmation before discarding the draft. */
  isDirty: boolean;
  onClose: () => void;
  /** Clears the draft — called when the user confirms discarding it. */
  onDiscard: () => void;
  onPublish: () => void;
  onClean: () => void;
  publishLoading: boolean;
  publishDisabled: boolean;
  children: ReactNode;
};

/** Mobile "add post" form — DS bottom sheet, with a cancel button and a discard confirmation. */
export function AddPostMobileSheet({
  open,
  isDirty,
  onClose,
  onDiscard,
  onPublish,
  onClean,
  publishLoading,
  publishDisabled,
  children
}: AddPostMobileSheetProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const requestClose = () => {
    if (isDirty) {
      setConfirmOpen(true);
      return;
    }
    onClose();
  };

  const confirmDiscard = () => {
    setConfirmOpen(false);
    onDiscard();
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={requestClose}
        disableEnforceFocus
        aria-labelledby="add-post-sheet-title"
        title="הוספת פוסט"
        cancelAction
        secondaryActions={[{ label: 'ניקוי', onClick: onClean }]}
        primaryAction={{
          label: 'פרסם',
          onClick: onPublish,
          loading: publishLoading,
          disabled: publishDisabled,
          color: 'secondary'
        }}
      >
        {children}
      </Dialog>

      <DynamicDialog
        open={confirmOpen}
        title="לבטל את הפוסט?"
        subtitle="התוכן שהזנת יימחק."
        handleOkClose={confirmDiscard}
        handleNotOkClose={() => setConfirmOpen(false)}
      />
    </>
  );
}
